import styled from 'styled-components';

export const RowList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 0;
  border-bottom: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};

  &:last-child {
    border-bottom: 0;
  }
`;

export const RowLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme: { colors = {} } }) => colors.onSurface ?? '#E6E6F2'};
`;

export const RowValue = styled.div`
  font-size: 13.5px;
  font-weight: 400;
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#C9C5D5'};
`;
